export default __webpack_public_path__ + "static/media/video.91280d21.svg";